function getInputErrorClass(error) {
  return error ? "input-error" : "";
}

export default getInputErrorClass;
